import React from "react";
import { CgClose } from "react-icons/cg";

import { Container, Content, Closer } from "./styles";

const Header = (props) => {
  return (
    <Container>
      <Content>{props.children}</Content>
      {!props.noCloser && (
        <Closer>
          <CgClose size={24} onClick={() => props.handler()} />
        </Closer>
      )}
    </Container>
  );
};

export default Header;
